<template>
  <div v-if="cluster_active_layer">
    <div v-if="is_popup_active" class="publish-popup">
      <b-modal
        size="lg"
        :active="is_popup_active"
        @close="is_popup_active = false"
        scrollable
      >
        <Popup
          @close="is_popup_active = false"
          :is_loading="is_loading"
          :project_uid="cluster_active_layer.projectUid"
          :asset_uid="cluster_active_layer.assets[0] && cluster_active_layer.assets[0].uid"
      
          @save="createTagsForOrtho"
        />
      </b-modal>
    </div>

    <div
      class="publish-btn button is-fixed"
      :class="{
        'is-success': !cluster_active_layer.published,
        'is-info': cluster_active_layer.published,
        'is-loading is-disabled': is_loading,
      }"
      @click="
        !cluster_active_layer.published ? publish() : unpublish()
      "
    >
      <span v-if="lang_data">
        {{
          !cluster_active_layer.published
            ? localization("app-publish", "Publish")
            : localization("app-unpublish", "Unpublish")
        }}
      </span>
    </div>
  </div>
</template>

<script>
import ApiService from "@/api.service";
import { mapMutations, mapState } from "vuex";
import Popup from "./publish-ortho-tags.vue";
export default {
  components: {
    Popup,
  },
  data() {
    return {
      is_loading: false,
      apiService: new ApiService(),
      teams_data: {},
      is_popup_active: false,
    };
  },
  computed: {
    ...mapState([
      "map",
      "draw",
      "orthos",
      "cluster_active_layer",
      "active_layers",
      "active_layer",
      "vectors",
    ]),
  },
  mounted() {
    if (window.addEventListener) {
      window.addEventListener(
        "message",
        (e) => {
          console.log(e);
          if (e.data.name === "add_teams") {
            console.log(e.data.data);
            this.teams_data = { ...e.data.data };
            this.publish();
          }
        },
        false
      );
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", (e) => {
        if (e.data.name === "add_teams") {
          console.log(e.data.data);
          this.teams_data = { ...e.data.data };
          this.publish();
        }
      });
    }
  },
  methods: {
    ...mapMutations([
      "UPDATE_ACTIVE_LAYERS",
      "SET_CLUSTER_ACTIVE_LAYER",
      "UPDATE_ORTHOS",
    ]),
    before_publish() {
      this.teams_data = {};
      let project = this.active_layers[this.cluster_active_layer.projectUid];
      let asset =
        (project &&
          project.info &&
          project.info.assets &&
          project.info.assets.length &&
          project.info.assets[0].uid) ||
        null;
      parent.postMessage(
        {
          name: "show_teams_popup",
          asset_id: asset,
        },
        "*"
      );
    },
    // async publish() {
    //   try {
    //     this.is_loading = true;
    //     let features = this.active_layers[this.cluster_active_layer.projectUid].features;
    //     let element_data = await this.apiService
    //       .create_elements({ body: { uids: features.map((feature) => feature.properties.uid) } })
    //       .catch((err) => {
    //         this.handleErrors(err);
    //         this.is_loading = false;
    //         this.$toast.open("Something went wrong");
    //       });
    //     // console.log(element_data)
    //     if (element_data.status !== 201 || _.isEmpty(element_data.data)) {
    //       let projectdata = await this.apiService.publish({ id: this.cluster_active_layer.projectUid });
    //       // update published value
    //       this.set_published(projectdata.data.updatedProject.published);
    //       this.is_loading = false;
    //       return;
    //     }
    //     // update features with elements created in local
    //     let features_with_elements = this.update_element_data(features, element_data.data);
    //     // add issue desc
    //     features_with_elements = features_with_elements.map((f) => {
    //       if (this.vectors[f.properties.class_id])
    //         return {
    //           ...f,
    //           properties: {
    //             ...f.properties,
    //             issue_description: this.vectors[f.properties.class_id].description,
    //             issue_group: this.vectors[f.properties.class_id].group,
    //           },
    //         };
    //       return f;
    //     });
    //     // create tickets for these updated features with element and issue_description
    //     let res = await this.apiService.create_tickets({ body: { issues: features_with_elements, attributes: this.teams_data } });
    //     // associate tickets created to features/ update the features locally
    //     if (res.status !== 200) {
    //       this.$toast.open("Failed to create tickets");
    //     } else {
    //       this.update_ticket_data(res.data.issues);
    //       // update therm with updated features which includes created ticket
    //       await this.update_therm(res.data.issues);
    //       let projectdata = await this.apiService.publish({ id: this.cluster_active_layer.projectUid });
    //       // update published value
    //       this.set_published(projectdata.data.updatedProject.published);
    //     }
    //     this.is_loading = false;
    //     this.teams_data = {};
    //   } catch (err) {
    //     this.is_loading = false;
    //     this.$toast.open("Failed to Publish");
    //   }
    // },
    async createTagsForOrtho(form) {
      this.is_loading = true;
      try {
        let tags = await this.apiService.create_tags(form);
        await this.publish();
        localStorage.setItem(
          `tags_for_ortho_asset_uid=${this.cluster_active_layer.assets[0] && this.cluster_active_layer.assets[0].uid}`,
          JSON.stringify(form)
        );
        this.is_loading = false;
        this.is_popup_active = false;
      } catch (err) {
        console.log(err);
        this.is_loading = false;
        this.is_popup_active = false;
      }
    },
    async publish() {
      try {
        this.is_loading = true;
        let projectdata = await this.apiService.publish({
          id: this.cluster_active_layer.projectUid,
        });
        this.set_published(projectdata.data.updatedProject.published);
        this.is_loading = false;
      } catch (err) {
        this.is_loading = false;
        this.$toast.open("Failed to Publish");
      }
    },
    set_published(published) {
     
      // update cluster_active_layer
      this.SET_CLUSTER_ACTIVE_LAYER({
        ...this.cluster_active_layer,
        published,
      });
      let active_layers = { ...this.active_layers };
      // update orthos
      let orthos = [...this.orthos];
      orthos.forEach((group, groupIndex) => {
        if (group[0].groupUid === this.cluster_active_layer.groupUid) {
          group.forEach((project, projectIndex) => {
            if (project.projectUid === this.cluster_active_layer.projectUid) {
              orthos[groupIndex][projectIndex] = {
                ...orthos[groupIndex][projectIndex],
                published,
              };
            }
          });
        }
      });
      this.UPDATE_ORTHOS(orthos);
      // update orthos active_layers
      active_layers[this.cluster_active_layer.projectUid].info.published =
        published;
      this.UPDATE_ACTIVE_LAYERS(active_layers);
    },
    async unpublish() {
      try {
        this.is_loading = true;
        let res = await this.apiService.unpublish({
          id: this.cluster_active_layer.projectUid,
        });
        let published = res.data.updatedProject.published;
        this.set_published(published);
        this.is_loading = false;
      } catch (err) {
        this.is_loading = false;
      }
    },
    update_element_data(features, elements) {
      // update in active_layers
      features = features.map((feature) => {
        feature.properties.element = elements[feature.properties.uid];
        return feature;
      });
      let active_layers = { ...this.active_layers };
      active_layers[this.cluster_active_layer.projectUid].features = features;
      this.UPDATE_ACTIVE_LAYERS(active_layers);

      // update on the map
      let draw_features = this.draw.getAll().features;
      draw_features = draw_features.map((feature) => {
        feature.properties.element =
          elements[feature.properties.uid] || feature.properties.element;
        return feature;
      });
      this.draw.set({ type: "FeatureCollection", features: draw_features });
      return features;
    },
    update_ticket_data(issues) {
      // update in active_layers
      let active_layers = { ...this.active_layers };
      active_layers[this.cluster_active_layer.projectUid].features = issues;
      this.UPDATE_ACTIVE_LAYERS(active_layers);
      // update on the map
      let issues_map = {};
      issues.forEach((f) => {
        issues_map[f.properties.uid] = f;
      });
      let draw_features = this.draw.getAll().features;
      draw_features = draw_features.map((feature) => {
        if (issues_map[feature.properties.uid])
          return issues_map[feature.properties.uid];
        return feature;
      });

      this.draw.set({ type: "FeatureCollection", features: draw_features });
    },
    async update_therm(issues) {
      await this.apiService
        .update_therm({
          body: {
            geojson: {
              type: "FeatureCollection",
              features: issues,
            },
          },
          id: this.cluster_active_layer.projectUid,
          query: "tables=false",
        })
        .catch((err) => {
          this.$toast.open("Could not create tickets");
          this.handleErrors(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.publish-btn {
  position: fixed;
  right: 1rem;
  bottom: 1rem;
}
::v-deep .modal {
  z-index: 10000;
}
</style>
